'use client';

import { useTranslations } from 'use-intl';

import { useSurveyTimer } from './shared-survey-progress-ring.hooks';

interface Props {
  estimatedTotalTimeInSeconds: number;
  progress: number;
  className?: string;
  numberClassName?: string;
  symbolClassName?: string;
}

/**
 * Mobile-friendly badge display for survey progress timer
 * Shows remaining time in a compact text format
 */
export default function SharedSurveyProgressBadge({
  estimatedTotalTimeInSeconds,
  progress,
  className = '',
  numberClassName = '',
  symbolClassName = '',
}: Props) {
  const t = useTranslations('Time');

  const { remainingMinutes } = useSurveyTimer({
    totalTimeInSeconds: estimatedTotalTimeInSeconds,
    progress,
  });

  return (
    <div
      className={`flex h-6 max-h-6 min-h-6 max-w-fit min-w-6 items-center justify-center rounded-xs bg-gray-100 p-1 ${className}`}
    >
      <div className='flex items-baseline justify-center'>
        <span className={`font-semibold text-gray-500 ${numberClassName}`}>
          {remainingMinutes}
        </span>
        <span
          className={`text-[8px] font-normal text-gray-500 ${symbolClassName}`}
        >
          {t('minutesShort')}
        </span>
      </div>
    </div>
  );
}
